document.addEventListener('DOMContentLoaded', function () {
  const upsellModal = document.getElementById('upsell-modal');
  const upsellProductsContainer = document.getElementById('upsell-products');
  const upsellClose = document.querySelectorAll('.close-btn');

  upsellClose.forEach(closeBtn => {
    closeBtn.addEventListener('click', () => {
      upsellModal.classList.remove('active');
      upsellModal.classList.add('hidden');
      document.querySelector('body').classList.remove('over-flow');
      window.location.href = window.routes.cart_url;
    });
  })  

  document.querySelectorAll('.product-form__submit').forEach(button => {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      const form = this.closest('form');
      const formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(res => res.json())
      .then(product => {
        fetch(`/recommendations/products.json?product_id=${product.product_id}&intent=complementary&limit=4`)
          .then(res => res.json())
          .then(data => {            
            if (data.products && data.products.length > 0) {
              console.log("complimentary products");              
              renderUpsellProducts(data.products);
              showUpsellModal();
            } else {
              window.location.href = '/cart';
            }
          });
      });
      function renderUpsellProducts(products) {
        upsellProductsContainer.innerHTML = '';
        products.forEach(item => {
          let imageSrc = item.featured_image;
          const imageUrl = new URL(imageSrc, window.location.origin);
          imageSrc = imageSrc + `${imageUrl.search.length > 0 ? '&width=400&height=400' : '?width=400&height=400'}`

          let comparePriceHTML = '';
          if (item.compare_at_price && item.compare_at_price > item.price) {
            comparePriceHTML = `<span class="compare-price" style="text-decoration: line-through; color: #888; margin-left: 5px;">${formatMoney(item.compare_at_price)}</span>`;
          }
          upsellProductsContainer.innerHTML += `
            <div class="upsell-product">
              <div class="image">
                <img src="${imageSrc}" alt="${item.title}">
              </div>
              <div class="product-info">
                <h3 class="product-title">${item.title}</h3>
                <div class="price-wrapper">                    
                  <p class="product-compare_price">${comparePriceHTML}</p>
                  <p class="product-price">${formatMoney(item.price)}</p>
                </div>
                <form action="/cart/add" method="post" class="upsell-form">
                  <input type="hidden" name="id" value="${item.variants[0].id}">
                  <button type="submit" class="product-form__submit button button--full-width button--secondary">Add to cart</button>
                </form>
              </div>
            </div>
          `;
        });
      }
      function showUpsellModal() {
        upsellModal.classList.add('active');
        upsellModal.classList.remove('hidden');
        document.querySelector('body').classList.add('over-flow');
      }
    });
  });
});

function formatMoney(price) {
  return (price / 100).toLocaleString('en-GB', {
    style: 'currency',
    currency: Shopify.currency.active
  });
}
